/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { SourcingSearchCertification } from './';
import {
    SourcingSearchCertificationFromJSON,
    SourcingSearchCertificationFromJSONTyped,
    SourcingSearchCertificationToJSON,
} from './';
import type { SourcingSearchEducation } from './';
import {
    SourcingSearchEducationFromJSON,
    SourcingSearchEducationFromJSONTyped,
    SourcingSearchEducationToJSON,
} from './';
import type { SourcingSearchExperience } from './';
import {
    SourcingSearchExperienceFromJSON,
    SourcingSearchExperienceFromJSONTyped,
    SourcingSearchExperienceToJSON,
} from './';
import type { SourcingSearchFreelancer } from './';
import {
    SourcingSearchFreelancerFromJSON,
    SourcingSearchFreelancerFromJSONTyped,
    SourcingSearchFreelancerToJSON,
} from './';
import type { SourcingSearchFreelancerType } from './';
import {
    SourcingSearchFreelancerTypeFromJSON,
    SourcingSearchFreelancerTypeFromJSONTyped,
    SourcingSearchFreelancerTypeToJSON,
} from './';
import type { SourcingSearchMatchingHighlight } from './';
import {
    SourcingSearchMatchingHighlightFromJSON,
    SourcingSearchMatchingHighlightFromJSONTyped,
    SourcingSearchMatchingHighlightToJSON,
} from './';
import type { SourcingSearchMatchingSkill } from './';
import {
    SourcingSearchMatchingSkillFromJSON,
    SourcingSearchMatchingSkillFromJSONTyped,
    SourcingSearchMatchingSkillToJSON,
} from './';
import type { SourcingSearchPhoto } from './';
import {
    SourcingSearchPhotoFromJSON,
    SourcingSearchPhotoFromJSONTyped,
    SourcingSearchPhotoToJSON,
} from './';

/**
 * 
 * @export
 * @interface SourcingSearchUnregisteredFreelancer
 */
export interface SourcingSearchUnregisteredFreelancer extends SourcingSearchFreelancer {
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchUnregisteredFreelancer
     */
    unregisteredUrl: string;
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchUnregisteredFreelancer
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchUnregisteredFreelancer
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchUnregisteredFreelancer
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchUnregisteredFreelancer
     */
    location?: string;
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchUnregisteredFreelancer
     */
    headline: string;
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchUnregisteredFreelancer
     */
    description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SourcingSearchUnregisteredFreelancer
     */
    keywords: Array<string>;
    /**
     * 
     * @type {Array<SourcingSearchExperience>}
     * @memberof SourcingSearchUnregisteredFreelancer
     */
    experiences?: Array<SourcingSearchExperience>;
    /**
     * 
     * @type {Array<SourcingSearchEducation>}
     * @memberof SourcingSearchUnregisteredFreelancer
     */
    educations?: Array<SourcingSearchEducation>;
    /**
     * 
     * @type {Array<SourcingSearchCertification>}
     * @memberof SourcingSearchUnregisteredFreelancer
     */
    certifications?: Array<SourcingSearchCertification>;
    /**
     * 
     * @type {Array<SourcingSearchMatchingSkill>}
     * @memberof SourcingSearchUnregisteredFreelancer
     */
    matchingSkills?: Array<SourcingSearchMatchingSkill>;
}

/**
 * Check if a given object implements the SourcingSearchUnregisteredFreelancer interface.
 */
export function instanceOfSourcingSearchUnregisteredFreelancer(value: object): value is SourcingSearchUnregisteredFreelancer {
    if (!('unregisteredUrl' in value) || value['unregisteredUrl'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('fullName' in value) || value['fullName'] === undefined) return false;
    if (!('headline' in value) || value['headline'] === undefined) return false;
    if (!('keywords' in value) || value['keywords'] === undefined) return false;
    return true;
}

export function SourcingSearchUnregisteredFreelancerFromJSON(json: any): SourcingSearchUnregisteredFreelancer {
    return SourcingSearchUnregisteredFreelancerFromJSONTyped(json, false);
}

export function SourcingSearchUnregisteredFreelancerFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingSearchUnregisteredFreelancer {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...SourcingSearchFreelancerFromJSONTyped(json, ignoreDiscriminator),
        'unregisteredUrl': json['unregisteredUrl'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'fullName': json['fullName'],
        'location': json['location'] == null ? undefined : json['location'],
        'headline': json['headline'],
        'description': json['description'] == null ? undefined : json['description'],
        'keywords': json['keywords'],
        'experiences': json['experiences'] == null ? undefined : ((json['experiences'] as Array<any>).map(SourcingSearchExperienceFromJSON)),
        'educations': json['educations'] == null ? undefined : ((json['educations'] as Array<any>).map(SourcingSearchEducationFromJSON)),
        'certifications': json['certifications'] == null ? undefined : ((json['certifications'] as Array<any>).map(SourcingSearchCertificationFromJSON)),
        'matchingSkills': json['matchingSkills'] == null ? undefined : ((json['matchingSkills'] as Array<any>).map(SourcingSearchMatchingSkillFromJSON)),
    };
}

export function SourcingSearchUnregisteredFreelancerToJSON(value?: SourcingSearchUnregisteredFreelancer | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...SourcingSearchFreelancerToJSON(value, true),
        'unregisteredUrl': value['unregisteredUrl'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'fullName': value['fullName'],
        'location': value['location'],
        'headline': value['headline'],
        'description': value['description'],
        'keywords': value['keywords'],
        'experiences': value['experiences'] == null ? undefined : ((value['experiences'] as Array<any>).map((v) => SourcingSearchExperienceToJSON(v))),
        'educations': value['educations'] == null ? undefined : ((value['educations'] as Array<any>).map((v) => SourcingSearchEducationToJSON(v))),
        'certifications': value['certifications'] == null ? undefined : ((value['certifications'] as Array<any>).map((v) => SourcingSearchCertificationToJSON(v))),
        'matchingSkills': value['matchingSkills'] == null ? undefined : ((value['matchingSkills'] as Array<any>).map((v) => SourcingSearchMatchingSkillToJSON(v))),
    };
}

